<app-page-frame frameTitle="Messages" titleIcon="bi bi-chat-square-dots" homeRoute="/user-management">
  <app-view-inbox></app-view-inbox>
</app-page-frame>
